export default {
  // text: 'What does this say?',
  text: 'Commerce for social video and beyond',
  // subheaderText: 'This part should also say something meaningful about the product.',
  subheaderText: 'Mobile-first commerce experiences that shorten the path to purchase'
}



// WEBPACK FOOTER //
// ./client/store/imports/HeaderContent.js